import React from "react";
import PageShell from "../components/layout/PageShell";

export default function MentionsLegales() {
  return (
    <PageShell
      title="Mentions légales"
      subtitle="Informations légales relatives au site officiel de l’École de la Magistrature."
    >
      <h2 className="ema-h3">Éditeur du site</h2>
      <p className="ema-paragraph">
        Le présent site est édité par l’<strong>École de la Magistrature (EMA)</strong>, institution de formation judiciaire.
      </p>

      <div className="ema-divider" />

      <h2 className="ema-h3">Responsable de publication</h2>
      <p className="ema-paragraph">
        Le responsable de publication est la Direction de l’École de la Magistrature ou toute personne dûment mandatée.
      </p>

      <div className="ema-divider" />

      <h2 className="ema-h3">Hébergement</h2>
      <p className="ema-paragraph">
        Le site est hébergé par un prestataire d’hébergement sécurisé. Les informations techniques d’hébergement peuvent être
        communiquées sur demande officielle.
      </p>

      <div className="ema-divider" />

      <h2 className="ema-h3">Propriété intellectuelle</h2>
      <p className="ema-paragraph">
        L’ensemble des contenus (textes, images, logos, documents, supports pédagogiques) présents sur ce site est protégé
        par les lois applicables. Toute reproduction, représentation, modification ou diffusion, totale ou partielle, est
        interdite sans autorisation préalable.
      </p>

      <div className="ema-divider" />

      <h2 className="ema-h3">Liens externes</h2>
      <p className="ema-paragraph">
        Le site peut contenir des liens vers d’autres sites. L’EMA ne peut être tenue responsable du contenu de ces sites
        tiers ni des éventuels dommages liés à leur utilisation.
      </p>

      <div className="ema-divider" />

      <h2 className="ema-h3">Contact</h2>
      <p className="ema-paragraph">
        Pour toute question relative au site, veuillez utiliser la page <strong>Contact</strong>.
      </p>
    </PageShell>
  );
}

